<template>
    <div>
        <el-table :data="orgPriceRecList" border style="width: 100%" height="565">
            <el-table-column type="index" label="服务次数" align="center" width="100">
                <template slot-scope="rows">
                    <span>{{rows.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="单次服务价格" width="120" align="right" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{parseFloat(rows.row.price).toFixed(2) || 0.00}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="bizAreaName" label="是否被使用" width="120" align="center" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{rows.row.bizVoucherId != -1 ? "是" : ""}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="bizVoucherNo" label="使用工单" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="histroyFlag" label="是否历史" width="100" align="center" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{rows.row.histroyFlag ? "是" : ""}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { MsgBox } from '../../app.vues'
    import contractApi from '../../api/contract';

    export default {
        name: 'swb-contract-servc-org-price-rec-list',
        desc: '单次价格预览',
        /**
         * servcQuantity: 服务总次数
         */
        props: ['comnRequire', "originalServcItemId", "bizUnitId", "servcQuantity", "amount", "price", "lastPrice"],
        data: function () {
            return {
                orgPriceRecList: [],
            }
        },
        created: function () {
            let self = this;
            if(!Utils.isNoB(this.originalServcItemId)) {
                this.getContractServcOrgPriceRecList();
            } else {
                this.makeOrgPriceRecList([]);
            }
        },
        methods: {
            getContractServcOrgPriceRecList: function () {
                let self = this;
                let postData = {};
                postData.originalServcItemId = this.originalServcItemId;
                postData.bizUnitId = this.bizUnitId;
                if(Utils.isTrue(this.comnRequire)) {
                    contractApi.getContractServc2OrgPriceRecList(postData, function (result) {
                        if(result.type == 'info') {
                            let dbPriceRecList = result.data || [];
                            self.makeOrgPriceRecList(dbPriceRecList);
                        } else {
                            MsgBox.warning(result.message, result.errid);
                        }
                    });
                } else {
                    contractApi.getContractServcOrgPriceRecList(postData, function (result) {
                        if(result.type == 'info') {
                            let dbPriceRecList = result.data || [];
                            self.makeOrgPriceRecList(dbPriceRecList);
                        } else {
                            MsgBox.warning(result.message, result.errid);
                        }
                    });
                }
            },
            makeOrgPriceRecList: function (dbPriceRecList) {
                let self = this;
                let quantity = this.servcQuantity - dbPriceRecList.length; // 需要虚拟生成的条数
                //
                let dbAmount = 0.00;
                if(dbPriceRecList.length > 0) {
                    for(let i = 0; i < dbPriceRecList.length; i++) {
                        let dbPriceRec = dbPriceRecList[i];
                        //
                        dbAmount += dbPriceRec.price;
                    }
                }
                if(quantity > 0) {
                    let price = this.price; // 以特定单次价格为准
                    for(let i = 0; i < quantity; i++) {
                        let priceRec = {
                            price: price,
                            bizVoucherId: -1,
                            histroyFlag: false,
                        };
                        if(i == (quantity - 1)) {
                            // 无最后价格，使用总价计算
                            let lastPrice = parseFloat((self.amount - dbAmount) - (price * (quantity - 1))).toFixed(2);
                            if(lastPrice < 0) {
                                priceRec.price = 0.00;
                            } else {
                                priceRec.price = lastPrice || 0.00;
                            }
                        }
                        dbPriceRecList.push(priceRec);
                    }
                }
                this.orgPriceRecList = Utils.merge([], dbPriceRecList);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcOrgPriceRecList.vue